// 判断参数是否是其中之一
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

export function firstUpperCase(str) {
  return str.toString()[0].toUpperCase() + str.toString().slice(1);
}

export function isParent(children, parent) {
  if (!parent) {
    return false;
  }
  while (children) {
    if (children === parent) {
      return true;
    }
    children = children.parentNode;
  }
  return false;
}
export function appendDomToRoot(el, selector) {
//el 为要操作的dom元素，selector为要插入的根节点的选择器，为空的话，直接插入到body中
  var container;
  if (selector) {
    container = document.querySelector(selector);
  }
  if (!container) {
    container = document.body;
    return;
  }
  container.appendChild(el);
}


// WEBPACK FOOTER //
// ./src/components/Utils.js